<template>
  <a-modal
    title="选择"
    :width="780"
    :visible="visible"
    :confirmLoading="loading"
    @ok="this.ok"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="userFetching">
      <a-form :form="form" v-bind="formLayout">
        <a-row>
          <a-col :span="24">
            <a-form-item label="员工" v-if="false">
              <a-select
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="userFetching ? undefined : null"
                show-search
                mode="multiple"
                placeholder="请输入用户名"
                @search="this.userSearch"
                @change="handleChange"
              >
                <a-spin v-if="userFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in userList" :key="d.id">
                  {{ d.name }}<span v-if="d.cell_phone1">（{{ d.cell_phone1 }}）</span>
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <a-transfer
        :titles="['人员列表', '目标人员']"
        :data-source="userList"
        :list-style="{
          width: '45%',
          height: '300px',
        }"
        :target-keys="targetKeys"
        :render="renderItem"
        @change="handleUserChange"
      />
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import debounce from 'lodash/debounce'
import AttachmentCreateForm from '../attachment/modules/CreateForm'
import { tradeUserList } from '@/api/trade_user'

// 表单字段
const fields = ['id', 'number', 'name', 'cash']
export default {
  components: {
    AttachmentCreateForm
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    },
    selectedKeys: {
      type: Array,
      default: () => []
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 2 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 22 }
      }
    }
    this.userSearch = debounce(this.handleUserSearch, 800)
    return {
      userFetching: false,
      userList: [],
      selectedUser: [],
      targetKeys: [],
      form: this.$form.createForm(this),
      visibleFrom: false,
      confirmLoading: false
    }
  },
  created () {
    console.log('custom modal created', this.form)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    this.$watch('model', () => {
      this.model && this.form.setFieldsValue(pick(this.model, fields))
    })
  },
  mounted () {
    this.handleUserSearch()
  },
  methods: {
    handleUserSearch (value) {
      this.userFetching = true
      tradeUserList({ name: value, page: 1, page_size: 999 }).then((res) => {
        const result = res.data.entries || []
        this.userList = result.map(item => {
          item['key'] = item.id + ''
          item['title'] = item.name
          item['chosen'] = Math.random() * 2 > 1
          return item
        })
      }).finally(() => {
        this.userFetching = false
      })
    },
    handleChange (selectedItems) {
      this.selectedUser = selectedItems
    },
    handleUserChange (targetKeys, direction, moveKeys) {
      console.log(targetKeys, direction, moveKeys)
      this.targetKeys = targetKeys
    },
    renderItem (item) {
      const customLabel = (
        <span class="custom-item">
          {item.name}
          {item.cell_phone1 ? <span>（{item.cell_phone1}）</span> : null}
        </span>
      )
      return {
        label: customLabel, // for displayed item
        value: item.id // for title and filter matching
      }
    },
    ok () {
      if (this.targetKeys.length === 0) {
        this.$message.warning('选择用户')
        return
      }
      const dataList = this.userList.filter(item => this.targetKeys.includes(item.id + ''))
      this.$emit('ok', dataList)
    }
  }
}
</script>
